import { BellOutlined, UserAddOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';

export interface MenuItem {
  id: number;
  title: string;
  link?: string;
  icon: ReactNode;
  childrens?: { id: number; title: string; link: string }[];
  filled?: boolean;
  secondaryLink?: string;
  onClick?: () => void;
  isActive?: boolean;
}

export const SidebarItems: MenuItem[] = [
  {
    id: 1,
    title: 'داشبورد',
    link: '/dashboard',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="28"
        viewBox="0 0 25 28"
        fill="none"
        className={'home-item'}
      >
        <path
          d="M12.7189 26.0505V25.0505V26.0505ZM22.0002 26.0505V25.0505V26.0505ZM11.4577 2.39723L10.8271 1.62112L11.4577 2.39723ZM2.17632 9.93834L2.80691 10.7145L2.17632 9.93834ZM0.4375 11.4906V24.0505H2.4375V11.4906H0.4375ZM10.8271 1.62112L1.54572 9.16223L2.80691 10.7145L12.0883 3.17335L10.8271 1.62112ZM13.3495 3.17335L22.6308 10.7145L23.892 9.16223L14.6106 1.62112L13.3495 3.17335ZM23.0002 11.4906V24.0505H25.0002V11.4906H23.0002ZM22.0002 25.0505L12.7189 25.0505V27.0505L22.0002 27.0505V25.0505ZM3.4375 27.0505H12.7189V25.0505H3.4375V27.0505ZM23.0002 24.0505C23.0002 24.6028 22.5525 25.0505 22.0002 25.0505V27.0505C23.6571 27.0505 25.0002 25.7074 25.0002 24.0505H23.0002ZM22.6308 10.7145C22.8645 10.9043 23.0002 11.1894 23.0002 11.4906H25.0002C25.0002 10.5872 24.5931 9.7319 23.892 9.16223L22.6308 10.7145ZM12.0883 3.17335C12.4557 2.87483 12.9821 2.87483 13.3495 3.17335L14.6106 1.62112C13.5084 0.725577 11.9293 0.725577 10.8271 1.62112L12.0883 3.17335ZM0.4375 24.0505C0.4375 25.7074 1.78065 27.0505 3.4375 27.0505V25.0505C2.88522 25.0505 2.4375 24.6028 2.4375 24.0505H0.4375ZM2.4375 11.4906C2.4375 11.1894 2.5732 10.9043 2.80691 10.7145L1.54572 9.16223C0.844593 9.7319 0.4375 10.5872 0.4375 11.4906H2.4375Z"
          fill="white"
        />
        <path
          d="M18.3592 19.8134H7.07782"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    ),
  },
  {
    id: 3,
    title: 'خرید و فروش',
    link: '/dashboard/orders/create-order',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="26"
        viewBox="0 0 22 26"
        fill="none"
      >
        <path
          d="M13.7765 18.3333H20.4432V25M8.4432 7.66667H1.77653V1M20.9999 9.00421C20.2524 7.15389 19.0007 5.55039 17.3872 4.37598C15.7737 3.20156 13.8634 2.50336 11.8729 2.36068C9.88235 2.21799 7.89128 2.63654 6.12679 3.56882C4.3623 4.5011 2.89496 5.90971 1.89111 7.63449M1.21924 16.9958C1.96682 18.8461 3.21848 20.4496 4.83196 21.624C6.44544 22.7984 8.35659 23.4967 10.3471 23.6394C12.3376 23.782 14.328 23.3634 16.0925 22.4312C17.857 21.4989 19.3237 20.0903 20.3275 18.3656"
          stroke="#859ABC"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    id: 5,
    title: 'کیف پول',
    link: '/dashboard/wallet',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="29"
        height="26"
        viewBox="0 0 29 26"
        fill="none"
      >
        <path
          d="M25.7144 19.2857V23C25.7144 24.1046 24.8189 25 23.7144 25H3.71436C2.60979 25 1.71436 24.1046 1.71436 23V3C1.71436 1.89543 2.60979 1 3.71436 1H23.7144C24.8189 1 25.7144 1.89543 25.7144 3V6.71429M25.7144 19.2857H15.7144C14.6098 19.2857 13.7144 18.3903 13.7144 17.2857V8.71429C13.7144 7.60972 14.6098 6.71429 15.7144 6.71429H25.7144M25.7144 19.2857H26.0001C27.1046 19.2857 28.0001 18.3903 28.0001 17.2857V8.71428C28.0001 7.60971 27.1046 6.71429 26.0001 6.71429H25.7144"
          stroke="#859ABC"
          stroke-width="2"
        />
        <path
          d="M20.5713 13H20.6284"
          stroke="#859ABC"
          stroke-width="3"
          stroke-linecap="round"
        />
      </svg>
    ),
    childrens: [
      {
        id: 64,
        title: 'موجودی',
        link: '/dashboard/wallet',
      },
      {
        id: 61,
        title: 'واریز تومانی',
        link: '/dashboard/wallet/deposit/IRT',
      },
      {
        id: 62,
        title: 'برداشت تومانی',
        link: '/dashboard/wallet/withdrawal/IRT',
      },
      {
        id: 62,
        title: 'واریز رمز ارز',
        link: '/dashboard/wallet/deposit/',
      },
      {
        id: 63,
        title: 'برداشت رمز ارز',
        link: '/dashboard/wallet/withdrawal/',
      },
    ],
  },
  {
    id: 7,
    title: 'سوابق',
    link: '/dashboard/orders',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M7 17.5H17.5M7 6.5H17.5M7 12H17.5"
          stroke="#859ABC"
          stroke-width="2"
          stroke-linecap="round"
        />
        <rect
          x="1"
          y="1"
          width="22"
          height="22"
          rx="1"
          stroke="#859ABC"
          stroke-width="2"
        />
      </svg>
    ),
    childrens: [
      {
        id: 61,
        title: ' خرید و فروش',
        link: '/dashboard/orders?type=0',
      },
      {
        id: 62,
        title: 'واریز و برداشت تومانی',
        link: '/dashboard/orders?type=1',
      },
      {
        id: 63,
        title: 'واریز و برداشت ارزی',
        link: '/dashboard/orders?type=2',
      },
      {
        id: 64,
        title: 'خرید و فروش ووچر پرفکت مانی',
        link: '/dashboard/orders?type=3',
      },
    ],
  },
  {
    id: 4,
    title: 'قیمت لحظه ای',
    link: '/dashboard/markets',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="29"
        height="26"
        viewBox="0 0 29 26"
        fill="none"
      >
        <path
          d="M9.5 11.5H3C1.89543 11.5 1 12.3954 1 13.5V24C1 24.5523 1.44772 25 2 25H9.5M9.5 11.5V3C9.5 1.89543 10.3954 1 11.5 1H16.5C17.6046 1 18.5 1.89543 18.5 3V7M9.5 11.5V25M18.5 7H25.5C26.6046 7 27.5 7.89543 27.5 9V24C27.5 24.5523 27.0523 25 26.5 25H18.5M18.5 7V25M18.5 25H9.5"
          stroke="#859ABC"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    ),
  },
  {
    id: 9,
    title: 'احراز هویت',
    link: '/dashboard/authentication',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="26"
        viewBox="0 0 28 26"
        fill="none"
      >
        <path
          d="M26.9998 8.42857V3C26.9998 1.89543 26.1044 1 24.9998 1H18.9998"
          stroke="#859ABC"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M26.9998 17.5714V23C26.9998 24.1046 26.1044 25 24.9998 25H18.9998"
          stroke="#859ABC"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M1.85693 8.42857V3C1.85693 1.89543 2.75236 1 3.85693 1H9.85693"
          stroke="#859ABC"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M1.85693 17.5714V23C1.85693 24.1046 2.75236 25 3.85693 25H9.85693"
          stroke="#859ABC"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M18 13.0001C18 15.2093 16.2091 17.0001 14 17.0001C11.7909 17.0001 10 15.2093 10 13.0001C10 10.791 11.7909 9.00012 14 9.00012C16.2091 9.00012 18 10.791 18 13.0001Z"
          stroke="#859ABC"
          stroke-width="2"
        />
      </svg>
    ),
  },
  {
    id: 8,
    title: 'حساب بانکی',
    link: '/dashboard/bank-accounts',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="26"
        viewBox="0 0 30 26"
        fill="none"
      >
        <path
          d="M8 18H16.5M29 10V3C29 1.89543 28.1046 1 27 1H3.5C2.39543 1 1.5 1.89543 1.5 3V10M29 10V23C29 24.1046 28.1046 25 27 25H3.5C2.39543 25 1.5 24.1046 1.5 23V10M29 10H1.5"
          stroke="#859ABC"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    ),
  },
  {
    id: 12,
    title: 'کسب درآمد',
    link: '/dashboard/referral',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
      >
        <path
          d="M24.9998 25H1.18164M20.9998 19.5455V13M13.0907 19.5455V13M5.18164 19.5455V13M12.1274 1.52946L1.52303 7.35782C1.43239 7.40764 1.46777 7.54545 1.5712 7.54545H24.6103C24.7137 7.54545 24.7491 7.40764 24.6584 7.35782L14.0541 1.52946C13.4542 1.19975 12.7273 1.19975 12.1274 1.52946Z"
          stroke="#859ABC"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    ),
  },
  // {
  //   id: 11,
  //   title: 'اعلانات',
  //   link: '/dashboard/notifications',
  //   icon: <BellOutlined />,
  // },
  {
    id: 10,
    title: 'حساب کاربری',
    link: '/dashboard/profile',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="26"
        viewBox="0 0 28 26"
        fill="none"
      >
        <path
          d="M24.9047 9.08359L24.4386 8.82428C24.3662 8.78401 24.33 8.7638 24.295 8.74286C23.9474 8.53464 23.6546 8.24643 23.4408 7.90224C23.4193 7.8676 23.3982 7.83181 23.3567 7.76003L23.3567 7.75998C23.3152 7.68814 23.2944 7.65205 23.2751 7.61605C23.0833 7.25797 22.9801 6.85924 22.9739 6.45308C22.9733 6.41643 22.974 6.37892 22.9751 6.31163L22.9755 6.28742L22.9845 5.75664C22.9991 4.88342 23.0064 4.44687 22.8842 4.0554C22.776 3.70908 22.5953 3.38979 22.3538 3.11909C22.0812 2.81362 21.7033 2.59584 20.9492 2.16129L20.9452 2.15903L20.3167 1.79682C19.5621 1.36197 19.1847 1.14464 18.784 1.06173C18.4296 0.988372 18.0636 0.991305 17.7105 1.07058C17.3123 1.15997 16.94 1.38291 16.1965 1.82806L16.1909 1.83147L15.7405 2.10114C15.6693 2.14378 15.6332 2.16505 15.5975 2.18489C15.2433 2.38183 14.8473 2.49141 14.4422 2.50441C14.4014 2.50572 14.3599 2.50572 14.2768 2.50572H14.2758C14.1932 2.50572 14.1522 2.50572 14.1115 2.50441C13.7056 2.49136 13.3082 2.38128 12.9535 2.18353C12.919 2.16433 12.8848 2.14378 12.8185 2.104L12.8108 2.09938L12.3576 1.82728L12.3542 1.82522C11.6063 1.37623 11.232 1.15152 10.8318 1.06173C10.4772 0.98217 10.1094 0.979503 9.75367 1.0538C9.35157 1.13779 8.97302 1.35746 8.21627 1.79667L7.59555 2.15693C6.84273 2.59386 6.46686 2.81222 6.19528 3.11791C5.95501 3.38834 5.77505 3.70689 5.66756 4.05229C5.54605 4.44272 5.55291 4.87795 5.56755 5.74825L5.57664 6.28878C5.57802 6.37064 5.57894 6.41159 5.57834 6.45185C5.57231 6.85884 5.46868 7.25842 5.27633 7.61714C5.25731 7.65261 5.23682 7.68808 5.1959 7.75892L5.19588 7.75896C5.15492 7.82987 5.13446 7.86524 5.11322 7.89947C4.89846 8.24549 4.60382 8.53506 4.25403 8.74363C4.21943 8.76426 4.18391 8.7841 4.11226 8.82381L3.65204 9.07885L3.65188 9.07894C2.88628 9.50321 2.50355 9.71531 2.22505 10.0175C1.97866 10.2848 1.79209 10.6019 1.67847 10.9472C1.55021 11.3371 1.5512 11.7742 1.55318 12.6473L1.55319 12.6508L1.55482 13.3663L1.55484 13.374C1.5568 14.2385 1.55778 14.6718 1.68612 15.0584C1.8 15.4014 1.98563 15.7162 2.23064 15.9819C2.50729 16.282 2.88697 16.4932 3.64523 16.915L3.64769 16.9164L4.10381 17.1701L4.11037 17.1738C4.18366 17.2145 4.22149 17.2356 4.25786 17.2575C4.60447 17.4662 4.89594 17.7546 5.10887 18.0987C5.13187 18.1358 5.15395 18.1744 5.19809 18.2515L5.19812 18.2516C5.24173 18.3277 5.26379 18.3658 5.28396 18.404C5.47065 18.7575 5.57154 19.1499 5.57836 19.5496C5.57909 19.5928 5.57841 19.6368 5.57693 19.7245L5.56817 20.2433L5.56814 20.2452C5.55342 21.1172 5.54605 21.5534 5.66818 21.9446C5.7763 22.291 5.95744 22.6102 6.19901 22.8809C6.47207 23.1869 6.84999 23.4051 7.60673 23.8411L8.23515 24.2033C8.98977 24.6381 9.36763 24.8554 9.76825 24.9383C10.1227 25.0117 10.4886 25.0087 10.8417 24.9294C11.24 24.84 11.6125 24.617 12.3565 24.1715L12.3613 24.1686L12.8117 23.8989C12.8829 23.8563 12.9188 23.835 12.9545 23.8152C13.3087 23.6182 13.7046 23.5086 14.1096 23.4956C14.1505 23.4943 14.192 23.4943 14.275 23.4943C14.3582 23.4943 14.4004 23.4943 14.4413 23.4956C14.8473 23.5087 15.244 23.6187 15.5988 23.8164C15.6345 23.8364 15.6704 23.8578 15.7417 23.9006L16.195 24.1727L16.1958 24.1732C16.9454 24.6233 17.3202 24.8483 17.7209 24.9382C18.0755 25.0177 18.4426 25.0206 18.7983 24.9463C19.2004 24.8623 19.5792 24.6426 20.336 24.2034L20.9567 23.8431C21.7095 23.4062 22.0854 23.1878 22.357 22.8821C22.5973 22.6117 22.7773 22.2932 22.8848 21.9478C23.0063 21.5573 22.9993 21.1222 22.9846 20.2519L22.9755 19.7113L22.9751 19.6842C22.974 19.6199 22.9733 19.5839 22.9739 19.5483C22.9799 19.1413 23.0834 18.7417 23.2757 18.383C23.2947 18.3475 23.3153 18.312 23.3562 18.2411C23.3971 18.1702 23.418 18.1347 23.4392 18.1005C23.654 17.7545 23.9483 17.4651 24.2981 17.2565C24.3316 17.2366 24.3664 17.2172 24.4336 17.18L24.4404 17.1762L24.9007 16.9212C25.6664 16.4969 26.0489 16.2848 26.3274 15.9826C26.5738 15.7152 26.76 15.3982 26.8737 15.0529C27.0021 14.6625 27.0016 14.2248 26.9996 13.3493L26.998 12.6338C26.996 11.7643 26.9949 11.3294 26.8662 10.9416C26.7523 10.5986 26.5665 10.2838 26.3215 10.0181C26.0446 9.71772 25.6646 9.50633 24.9047 9.08359Z"
          stroke="#859ABC"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
];
